import { enableProdMode, mergeApplicationConfig } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { APP_BROWSER_CONFIG } from './app/app.browser.config';
import { APP_COMMON_CONFIG } from './app/app.common.config';
import { AppComponent } from './app/components/app.component';
import { environment } from './environments/environment';

// eslint-disable-next-line @typescript-eslint/naming-convention
declare let __webpack_public_path__: unknown;

/**
 * in order to correctly retrieve lazy loaded app bundle files from a versioned
 * deployment location like S3, update webpack public path with dynamic path:
 * - in Hybris hostContext: window.__env.hdms.resourcePath
 * - in standalone or AEM hostContext: window.hdmsResourcePath
 */
const resourcePath = window['__env']?.hdms?.resourcePath || window['hdmsResourcePath'];
if (resourcePath !== null && resourcePath !== undefined) {
  // eslint-disable-next-line unused-imports/no-unused-vars
  __webpack_public_path__ = resourcePath + (resourcePath.endsWith('/') ? '' : '/');
}

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () =>
  bootstrapApplication(AppComponent, mergeApplicationConfig(APP_COMMON_CONFIG, APP_BROWSER_CONFIG))
);
